// extracted by mini-css-extract-plugin
export default {"avatarButton":"SuperuserMenu-SuperuserMenu-module__avatarButton--Kvlh3","education":"SuperuserMenu-SuperuserMenu-module__education--Ycl0z"};